import he from 'he';

export const htmlDecode = (input) => {
  return he.decode(input || '');
};
